// libs
import axios, { AxiosResponse } from 'axios';
// App
import { Reservation } from '../reservation.interface';
import { RESERVATION_STATUS } from '../reservation-status.type';
import { CreateShopReservationParam } from '../create-shop-reservation-param.interface';
import { UpdateShopReservationParam } from '../update-shop-reservation-param.interface';
import { buildKeyUrl, buildShopReservationsUrl } from './reservation-urls.utils';

export const createShopReservation = (
  shopId: number,
  param: CreateShopReservationParam
): Promise<AxiosResponse<Reservation>> => {
  return axios.post(buildShopReservationsUrl(shopId), param);
};

export const updateShopReservation = (
  shopId: number,
  reservationId: number,
  param: UpdateShopReservationParam
): Promise<AxiosResponse<Reservation>> => {
  return axios.patch(`${buildShopReservationsUrl(shopId)}/${reservationId}`, param);
};

export const updateShopReservationStatus = (
  shopId: number,
  reservationId: number,
  status: RESERVATION_STATUS
): Promise<AxiosResponse<Reservation>> => {
  return axios.patch(`${buildShopReservationsUrl(shopId)}/${reservationId}/status`, { status });
};

export const requestReservationReconfirmation = (
  shopId: number,
  reservationId: number
): Promise<AxiosResponse<Reservation>> => {
  return axios.post(`${buildShopReservationsUrl(shopId)}/${reservationId}/reconfirmation-request`);
};

export const acceptReservationByKey = (key: string): Promise<AxiosResponse<Reservation>> => {
  return axios.post(buildKeyUrl('accept', key));
};

export const rejectReservationByKey = (key: string): Promise<AxiosResponse<Reservation>> => {
  return axios.post(buildKeyUrl('reject', key));
};
